/**
 * @generated SignedSource<<0a532f9b67152cb3e6cbac4a92cd3751>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespMainContent_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilters_viewer" | "SbRespRefineMenuDrawer_viewer" | "SbRespRefineMenuSelector_viewer" | "SbRespSearchResultContainer_viewer" | "SbSharedRecentlySoldItems_viewer" | "SbSharedRelatedItems_viewer">;
  readonly " $fragmentType": "SbRespMainContent_viewer";
};
export type SbRespMainContent_viewer$key = {
  readonly " $data"?: SbRespMainContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespMainContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespMainContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRecentlySoldItems_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuDrawer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespQuickFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "872efae81079bcb6c67d61134d9933ce";

export default node;
